import { render, staticRenderFns } from "./BundleServicesModal.vue?vue&type=template&id=2805e5ec&scoped=true"
import script from "./BundleServicesModal.vue?vue&type=script&lang=js"
export * from "./BundleServicesModal.vue?vue&type=script&lang=js"
import style0 from "./BundleServicesModal.vue?vue&type=style&index=0&id=2805e5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805e5ec",
  null
  
)

export default component.exports